import React from 'react';

const IconSections = () => (
  <svg width='24' height='24' viewBox='0 -1 24 23' fill='#0070b4' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5 3C3.90694 3 3 3.90694 3 5V20C3 21.0931 3.90694 22 5 22H19C20.0931 22 21 21.0931 21 20V5C21 3.90694 20.0931 3 19 3H5ZM5 5H19V20H5V5ZM7 6V8H17V6H7ZM7 10V15H17V10H7ZM7 17V19H17V17H7Z' />
  </svg>
);

export default IconSections;
